/**
 * Created by Vernost.yang on 5/18/2017.
 */
import { OnInit, Component } from "@angular/core";
import { Router } from "@angular/router";
import { VernostServiceService } from "../../services/vernost-service.service";
import { Login } from "../../models/login";
// import { element } from "@angular/core/src/render3/instructions";

@Component({
  selector: "home",
  templateUrl: "./home.component.html"
})
export class HomeComponent implements OnInit {
  public doughnutChartData: number[] = [0, 0, 0];
  public doughnutChartType: string = "doughnut";
  StatusArray: any = [];
  uid: string;
  loader = false;
  loginInfo: Login = {
    first_name: "Swapnil",
    last_name: "Mane",
    avatar: "vernost.png",
    title: "00210120121"
  };
  dropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data avaialble'
  };
  affPartners: any = [];
  accrualTypes: any = ["Accrual", "SWIM"];
  selectedAccuralType: any = [];
  selectedAffPartner: any = [];
  constructor(
    private router: Router,
    private vernostService: VernostServiceService
  ) {}

  ngOnInit() {
    // this.uid = localStorage.getItem('uid');
    //this.getStatus();
    this.getChartData();
  }

  logout(): void {
    // console.log("Logout");
    // this.authService.logout();
    localStorage.removeItem("uid");
    this.router.navigate(["/login"]);
  }

  public doughnutChartLabels: string[] = ["Booked", "Failed", "Cancel"];

  Booked: number = 0;
  Failed: number = 0;
  Cancel: number = 0;
  international: number = 0;
  domestic: number = 0;
  miles: number = 0;
  cash: number = 0;
  milesreedemed: number = 0;
  milescashreedemed: number = 0;
  Con_Fee_with_gst: number = 0;
  Con_Fee_without_gst: number = 0;
  CashPlusMilesInUbR: number = 0;
  TotalmilesPlusCash: number = 0;
  // events
  // public chartClicked(e: any): void {
  //   console.log(e);
  // }

  // public chartHovered(e: any): void {
  //   console.log(e);
  // }
  typeOfRedemption: any = "A";
  chartData: any = [];
  getChartData() {
    var url = "Scheduler";
    console.log("this.selectedAffPartner ===> ", this.selectedAffPartner)
    if (this.typeOfRedemption != 'AAF') {
      this.selectedAffPartner = [];
    }
    if (this.typeOfRedemption != 'A') {
      this.selectedAccuralType = [];
    }
    var data = {
      typeOfRedemption: this.typeOfRedemption,
      affPartners: this.selectedAffPartner,
      accuralType: this.selectedAccuralType
    };
    this.vernostService.postData(url, data).subscribe(response => {
      this.chartData = response;
     console.log("Scheduler:::", JSON.stringify(this.chartData));

      //console.log("sss", JSON.stringify(this.chartData));

      this.Booked = this.chartData[1].booked;
      this.Failed = this.chartData[0].failed;
      this.Cancel = this.chartData[2].cancel;

      this.international = this.chartData[3].international;
      this.domestic = this.chartData[4].domestic;
      this.miles = this.chartData[5].miles;
      this.cash = this.chartData[6].cash;
      //************************************ */
      this.milesreedemed = this.chartData[7].milesreedemed;
      this.milescashreedemed = this.chartData[8].milescashreedemed;
      this.Con_Fee_with_gst = this.chartData[9].Con_Fee_Miles;
      this.Con_Fee_without_gst = this.chartData[10].Con_Fee_Cash;
      this.CashPlusMilesInUbR = this.chartData[11].CashPlusMilesInUBR;
      this.TotalmilesPlusCash =this.chartData[8].milescashreedemed;
      if (this.affPartners.length == 0) {
        this.affPartners = this.chartData[12].affPartners || [];  
      }
      
        // parseInt(this.chartData[11].CashPlusMilesInUBR) +
        // parseInt(this.chartData[5].miles);
      //***************************************** */
      console.log("this.Booked, this.Failed, this.Cancel",this.Booked, this.Failed, this.Cancel)
      this.doughnutChartData = [this.Booked, this.Failed, this.Cancel];
    });
  }
  selectTypeOfRedemption(type) {
    console.log("TYPE:::::::::::::::", type);
    this.typeOfRedemption = type;
    this.getChartData();
  }
  getStatus() {
    var data = { id: 1 };
    this.vernostService.getPaiStatus(data).subscribe(response => {
      // console.log(
      //   "here is***********************************=",
      //   JSON.stringify(response)
      // );
      // alert(JSON.stringify(response));
      this.StatusArray = response;
      // this.doughnutChartData //parseInt(this.StatusArray[0].TRANX);
      // this.doughnutChartData[1 9; //parseInt(this.StatusArray[1].CRISS);
      // this.doughnutChartData[2] = 10; // parseInt(this.StatusArray[2].BOOK);
      //  this.doughnutChartData = [parseInt(this.StatusArray[2].BOOK), 0];
    });
  }

  onItemSelect(item: any) {
    console.log(item);
    this.getChartData();
  }
  onSelectAll(items: any, isUBAType) {
    console.log(items);
    if (!isUBAType) {
      this.selectedAffPartner = items;
    } else {
      this.selectedAccuralType = items;
    }
    this.getChartData();
  }
}
